export interface GetProjectsFinancialModel {

  projectId: string;
  fileId: string;
  preferredScenarioTitle: string;
  preferredScenarioNumber: string;
  type: string;
  version: string;
  lastReadProperties: string[];
  errors: FinancialModelError[];
  needExplanation: boolean;

}
export interface FinancialModelError {

  financialModelRef: string;
  propertyName: string;
  propertyPath: string;
  errorMessage: string;
  errorType: FinancialModelErrorType;

}
export enum FinancialModelErrorType {

  UNDEFINED = 'UNDEFINED',
  EMPTY = 'EMPTY',
  MISSING = 'MISSING',
  BAD_DATA_TYPE = 'BAD_DATA_TYPE',
  BAD_VALUE = 'BAD_VALUE',
  INTERNAL = 'INTERNAL',

}
export const financialModelErrorToTooltip: {[value: string]: string} = {
  [FinancialModelErrorType.UNDEFINED]: 'The type of this error is not specified',
  [FinancialModelErrorType.MISSING]: 'The data field is missing in the Financial Model',
  [FinancialModelErrorType.EMPTY]: 'The data field is present in the Financial Model but the Cell is empty',
  [FinancialModelErrorType.BAD_DATA_TYPE]: 'DigiRES was expecting a number but found a text',
  [FinancialModelErrorType.BAD_VALUE]: 'DigiRES was expecting a type of value (e.g. as set out in a Drop Down List) but found a different value',
  [FinancialModelErrorType.INTERNAL]: 'Please contact the DigiRES support team',
};
